module.exports = __webpack_public_path__ + "img/loader_outer.820a216d.png";